module.exports = __webpack_public_path__ + "static/media/gob2.f5770ed5.png";